import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useStoreActions, useStoreState } from 'easy-peasy';
import SectionTopMenu from '../../shared/components/SectionTopMenu/SectionTopMenu';
import PromotionHeader from './components/PromotionHeader';
import PromotionFilter from './components/PromotionFilter';
import PromotionReviewsGallery from './components/PromotionReviewsGallery';

const Promotion = () => {
  const params = useParams();
  const currentClient = useStoreState(state => state.currentClient);
  const currentPromotion = useStoreState(state => state.currentPromotion);
  const setCurrentClient = useStoreActions(actions => actions.setCurrentClient);
  const setCurrentPromotion = useStoreActions(actions => actions.setCurrentPromotion);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setCurrentClient(params.clientId);
    setCurrentPromotion(params.promotionId);
    console.log(`currentClient: ${currentClient}`);
    console.log(`currentPromotion: ${currentPromotion}`);
    setIsLoading(false);
  }, []);
  return isLoading ? null : (
    <div>
      <SectionTopMenu clientName={currentClient.name} promotionName={currentPromotion.name} />
      <PromotionHeader
        liveEnabled={currentPromotion.liveEnabled}
        showEnabled={currentPromotion.showEnabled}
        mapsEnabled={false}
        configuratorEnabled={false}
        digitalShowUrl={currentPromotion.digitalShowUrl}
      />
      <PromotionFilter />
      {currentPromotion.deliveries.map(delivery => (
        <PromotionReviewsGallery
          categoryId={delivery.categoryId}
          categoryName={delivery.categoryName}
          closedReviews={delivery.closedReviews}
          totalReviews={delivery.totalReviews}
          reviews={delivery.reviews}
        />
      ))}
    </div>
  );
};

export default Promotion;
